import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@volca/ui/components/ui/line-clamped-tooltip";
import { CustomerWithReferralsAndPayouts } from "@/customer/customer";

export const CustomerNameCol =
  (): ColumnDef<CustomerWithReferralsAndPayouts> => ({
    id: "name",
    header: "Customer name",
    accessorFn: (row) => row.name ?? "-",
    enableSorting: true,
    size: 178,
    minSize: 178,
    cell: ({ getValue }) => (
      <LineClampedTooltip>{getValue() as string}</LineClampedTooltip>
    ),
  });
